import apiClient from "./apiClient";
import {
  YardImportResponse,
  YardInstanceResponse,
  YardInstanceSaveRequest,
  YardLookupsResponse,
  YardReviewResponse,
  YardSaveResponse,
  YardTemplateResponse,
  YardTemplateSaveRequest,
  YardWeekResponse,
} from "yard/models";

const getLookups = async (hubId: number): Promise<YardLookupsResponse> =>
  apiClient.post(`/yard/lookups`, { hubId });

const getTemplate = async (hubId: number): Promise<YardTemplateResponse> =>
  apiClient.post(`/yard/template`, { hubId });

const saveTemplate = async (request: YardTemplateSaveRequest): Promise<YardSaveResponse> =>
  apiClient.post(`/yard/template/save`, request);

const getWeek = async (hubId: number, weekOf: string): Promise<YardWeekResponse> =>
  apiClient.post(`/yard/week`, { hubId, weekOf });

const importWeek = async (hubId: number, weekOf: string): Promise<YardImportResponse> =>
  apiClient.post(`/yard/week/import`, { hubId, weekOf });

const getInstance = async (yardDailyId: number): Promise<YardInstanceResponse> =>
  apiClient.get(`/yard/instance/${yardDailyId}`);

const findInstance = async (search: string): Promise<YardInstanceResponse> =>
  apiClient.get(`/yard/instance/search/${encodeURIComponent(search)}`);

const saveInstance = async (request: YardInstanceSaveRequest): Promise<YardSaveResponse> =>
  apiClient.post(`/yard/instance/save`, request);

const getReviews = async (hubIds: number[], approved: boolean): Promise<YardReviewResponse> =>
  apiClient.post(`/yard/reviews`, { hubIds, approved });

const approve = async (yardDailyId: number): Promise<YardSaveResponse> =>
  apiClient.post(`/yard/reviews/approve`, { yardDailyId });

const yardService = {
  getLookups,
  getTemplate,
  saveTemplate,
  getWeek,
  importWeek,
  getInstance,
  findInstance,
  saveInstance,
  getReviews,
  approve,
};

export default yardService;
